import React, { useState } from 'react';

const FIELD_TYPES = ['Single-line text','Multi-line text','Email','Phone','Dropdown','Checkbox','Number','Date'];

const INITIAL_FORMS = [
  {
    id:1, name:'Club Sign-up Form', status:'Active', submissions:312, views:1840,
    created:'Jan 15, 2026', embedType:'Inline',
    fields:[
      { id:1, label:'First name',    type:'Single-line text', required:true  },
      { id:2, label:'Last name',     type:'Single-line text', required:true  },
      { id:3, label:'Email',         type:'Email',            required:true  },
      { id:4, label:'Club name',     type:'Single-line text', required:true  },
      { id:5, label:'Country',       type:'Dropdown',         required:true  },
      { id:6, label:'Phone',         type:'Phone',            required:false },
    ]
  },
  {
    id:2, name:'Scout Application Form', status:'Active', submissions:187, views:940,
    created:'Jan 20, 2026', embedType:'Popup',
    fields:[
      { id:1, label:'Full name',     type:'Single-line text', required:true  },
      { id:2, label:'Email',         type:'Email',            required:true  },
      { id:3, label:'Phone',         type:'Phone',            required:false },
      { id:4, label:'Region',        type:'Dropdown',         required:true  },
      { id:5, label:'Certification', type:'Single-line text', required:false },
    ]
  },
  {
    id:3, name:'Contact Us Form', status:'Active', submissions:54, views:320,
    created:'Feb 1, 2026', embedType:'Inline',
    fields:[
      { id:1, label:'Name',    type:'Single-line text', required:true  },
      { id:2, label:'Email',   type:'Email',            required:true  },
      { id:3, label:'Message', type:'Multi-line text',  required:true  },
    ]
  },
];

const RECENT_SUBMISSIONS = [
  { name:'James Morris',   email:'james.morris@arsenal.com',         form:'Club Sign-up Form',   date:'Apr 3, 2026 09:14' },
  { name:'Alex Aldridge',  email:'alex.aldridge@coloradorapids.com', form:'Scout Application',   date:'Apr 3, 2026 08:55' },
  { name:'Pierre Dubois',  email:'p.dubois@psg.fr',                  form:'Club Sign-up Form',   date:'Apr 2, 2026 16:30' },
  { name:'Fatou Diop',     email:'f.diop@gmail.com',                 form:'Scout Application',   date:'Apr 2, 2026 14:10' },
  { name:'Luca Bianchi',   email:'l.bianchi@juventus.com',           form:'Contact Us Form',     date:'Apr 1, 2026 11:22' },
];

const statusBadge = s => s === 'Active' ? 'badge badge-green' : 'badge badge-gray';

let fieldId = 100;

export default function Forms({ toast }) {
  const [forms, setForms]         = useState(INITIAL_FORMS);
  const [editing, setEditing]     = useState(null);
  const [creating, setCreating]   = useState(false);
  const [newName, setNewName]     = useState('');
  const [tab, setTab]             = useState('forms');
  const [showEmbed, setShowEmbed] = useState(null);

  const editingForm = forms.find(f => f.id === editing);

  const createForm = () => {
    if (!newName.trim()) return;
    const f = { id:Date.now(), name:newName, status:'Active', submissions:0, views:0, created:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}), embedType:'Inline', fields:[{ id:1, label:'Email', type:'Email', required:true }] };
    setForms(prev=>[...prev,f]);
    setCreating(false); setNewName('');
    setEditing(f.id);
    toast?.('Form created');
  };

  const addField = formId => {
    setForms(prev=>prev.map(f=>f.id===formId?{...f,fields:[...f.fields,{id:++fieldId,label:'New field',type:'Single-line text',required:false}]}:f));
  };

  const updateField = (formId, fieldId, key, val) => {
    setForms(prev=>prev.map(f=>f.id===formId?{...f,fields:f.fields.map(fi=>fi.id===fieldId?{...fi,[key]:val}:fi)}:f));
  };

  const removeField = (formId, fieldId) => {
    setForms(prev=>prev.map(f=>f.id===formId?{...f,fields:f.fields.filter(fi=>fi.id!==fieldId)}:f));
  };

  const embedCode = form => `<script src="https://js.transferexpo.com/forms/v1.js"></script>\n<div id="tf-form-${form.id}"></div>\n<script>\n  TransferExpoForms.create({\n    formId: "${form.id}",\n    target: "#tf-form-${form.id}"\n  });\n</script>`;

  if (editingForm) {
    return (
      <div>
        <button className="btn btn-ghost" style={{ marginBottom:16,fontSize:13 }} onClick={()=>setEditing(null)}>← Back to forms</button>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <h2 style={{ fontFamily:'var(--font-display)',fontSize:20,fontWeight:500,color:'var(--text-primary)' }}>{editingForm.name}</h2>
          <div style={{ display:'flex',gap:8 }}>
            <button className="btn btn-ghost" onClick={()=>setShowEmbed(editingForm)}>{'</>'} Embed code</button>
            <button className="btn btn-primary" onClick={()=>{ setEditing(null); toast?.('Form saved'); }}>Save form</button>
          </div>
        </div>

        <div style={{ display:'grid',gridTemplateColumns:'1fr 360px',gap:20 }}>
          {/* Field editor */}
          <div className="card">
            <div className="card-header"><span className="card-title">Form fields</span></div>
            {editingForm.fields.map((field,i) => (
              <div key={field.id} style={{ padding:'12px 0',borderBottom:'1px solid var(--border)' }}>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr auto auto',gap:8,alignItems:'center' }}>
                  <input className="search-input" value={field.label} onChange={e=>updateField(editingForm.id,field.id,'label',e.target.value)} placeholder="Field label" style={{ fontSize:13 }}/>
                  <select className="search-input" value={field.type} onChange={e=>updateField(editingForm.id,field.id,'type',e.target.value)} style={{ fontSize:13 }}>
                    {FIELD_TYPES.map(t=><option key={t}>{t}</option>)}
                  </select>
                  <label style={{ display:'flex',alignItems:'center',gap:6,cursor:'pointer',fontSize:12,color:'var(--text-muted)',whiteSpace:'nowrap' }}>
                    <input type="checkbox" checked={field.required} onChange={e=>updateField(editingForm.id,field.id,'required',e.target.checked)}/>
                    Required
                  </label>
                  <button style={{ background:'none',border:'none',color:'#ff4d4d',cursor:'pointer',fontSize:18,lineHeight:1 }} onClick={()=>removeField(editingForm.id,field.id)}>×</button>
                </div>
              </div>
            ))}
            <button className="btn btn-ghost" style={{ marginTop:12,fontSize:13 }} onClick={()=>addField(editingForm.id)}>+ Add field</button>
          </div>

          {/* Preview */}
          <div className="card">
            <div className="card-header"><span className="card-title">Live preview</span></div>
            <div style={{ display:'flex',flexDirection:'column',gap:14 }}>
              {editingForm.fields.map(field=>(
                <div key={field.id}>
                  <label style={{ fontSize:12,color:'var(--text-muted)',display:'block',marginBottom:5 }}>
                    {field.label}{field.required&&<span style={{ color:'#ff4d4d',marginLeft:2 }}>*</span>}
                  </label>
                  {field.type==='Multi-line text'
                    ? <textarea className="search-input" rows={3} style={{ resize:'none' }} placeholder={field.label} readOnly/>
                    : field.type==='Dropdown'
                    ? <select className="search-input"><option>{field.label}...</option></select>
                    : field.type==='Checkbox'
                    ? <label style={{ display:'flex',alignItems:'center',gap:8,fontSize:13,color:'var(--text-muted)',cursor:'pointer' }}><input type="checkbox"/>{field.label}</label>
                    : <input className="search-input" type={field.type==='Email'?'email':field.type==='Phone'?'tel':field.type==='Number'?'number':field.type==='Date'?'date':'text'} placeholder={field.label} readOnly/>}
                </div>
              ))}
              <button className="btn btn-primary" style={{ marginTop:4 }}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total forms</div><div className="stat-value">{forms.length}</div><div className="stat-sub">Active forms</div></div>
        <div className="stat-card"><div className="stat-label">Total submissions</div><div className="stat-value">{forms.reduce((s,f)=>s+f.submissions,0).toLocaleString()}</div><div className="stat-sub stat-up">All forms</div></div>
        <div className="stat-card"><div className="stat-label">Total views</div><div className="stat-value">{forms.reduce((s,f)=>s+f.views,0).toLocaleString()}</div><div className="stat-sub">Form impressions</div></div>
        <div className="stat-card"><div className="stat-label">Avg conversion</div><div className="stat-value">{Math.round((forms.reduce((s,f)=>s+f.submissions,0)/forms.reduce((s,f)=>s+f.views,0))*100)}%</div><div className="stat-sub">View → submit</div></div>
      </div>

      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16 }}>
        <div className="filter-pills" style={{ marginBottom:0 }}>
          {['forms','submissions'].map(t=>(
            <button key={t} className={`pill ${tab===t?'active':''}`} onClick={()=>setTab(t)} style={{ textTransform:'capitalize' }}>{t}</button>
          ))}
        </div>
        <button className="btn btn-primary" onClick={()=>setCreating(true)}>+ Create form</button>
      </div>

      {creating&&(
        <div className="card" style={{ marginBottom:16,padding:'16px 20px' }}>
          <p style={{ fontSize:13,color:'var(--text-muted)',marginBottom:10 }}>Form name</p>
          <div style={{ display:'flex',gap:10 }}>
            <input className="search-input" placeholder="e.g. Club Sign-up Form" value={newName} onChange={e=>setNewName(e.target.value)} autoFocus/>
            <button className="btn btn-primary" onClick={createForm}>Create</button>
            <button className="btn btn-ghost" onClick={()=>setCreating(false)}>Cancel</button>
          </div>
        </div>
      )}

      {tab==='forms'&&(
        <div className="card" style={{ padding:0 }}>
          <div className="card-header" style={{ padding:'16px 20px',borderBottom:'1px solid var(--border)' }}>
            <span className="card-title">All forms</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Form name</th><th>Fields</th><th>Submissions</th><th>Views</th><th>Conversion</th><th>Embed type</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {forms.map(f=>(
                  <tr key={f.id}>
                    <td style={{ fontWeight:500 }}>{f.name}</td>
                    <td>{f.fields.length}</td>
                    <td style={{ color:'var(--accent)',fontWeight:600 }}>{f.submissions.toLocaleString()}</td>
                    <td>{f.views.toLocaleString()}</td>
                    <td style={{ fontWeight:600 }}>{f.views?Math.round((f.submissions/f.views)*100)+'%':'—'}</td>
                    <td style={{ color:'var(--text-muted)',fontSize:12 }}>{f.embedType}</td>
                    <td><span className={statusBadge(f.status)}>{f.status}</span></td>
                    <td style={{ display:'flex',gap:4 }}>
                      <button className="btn btn-primary" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>setEditing(f.id)}>Edit</button>
                      <button className="btn btn-ghost" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>setShowEmbed(f)}>{'</>'}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab==='submissions'&&(
        <div className="card" style={{ padding:0 }}>
          <div className="card-header" style={{ padding:'16px 20px',borderBottom:'1px solid var(--border)' }}>
            <span className="card-title">Recent submissions</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Email</th><th>Form</th><th>Date</th></tr></thead>
              <tbody>
                {RECENT_SUBMISSIONS.map((s,i)=>(
                  <tr key={i}>
                    <td style={{ fontWeight:500 }}>{s.name}</td>
                    <td style={{ color:'var(--text-muted)',fontSize:12 }}>{s.email}</td>
                    <td style={{ fontSize:12 }}>{s.form}</td>
                    <td style={{ color:'var(--text-dim)',fontSize:12 }}>{s.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showEmbed&&(
        <div className="modal-overlay" onClick={()=>setShowEmbed(null)}>
          <div className="modal-box" onClick={e=>e.stopPropagation()} style={{ maxWidth:580 }}>
            <div className="modal-header"><h2>Embed — {showEmbed.name}</h2><button className="modal-close" onClick={()=>setShowEmbed(null)}>✕</button></div>
            <div className="modal-body">
              <p style={{ fontSize:13,color:'var(--text-muted)',marginBottom:14 }}>Copy and paste this code into your website wherever you want the form to appear.</p>
              <pre style={{ background:'var(--bg-input)',padding:16,borderRadius:8,fontSize:12,color:'var(--accent)',overflowX:'auto',lineHeight:1.6,whiteSpace:'pre-wrap' }}>{embedCode(showEmbed)}</pre>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setShowEmbed(null)}>Close</button>
              <button className="btn btn-primary" onClick={()=>{navigator.clipboard?.writeText(embedCode(showEmbed));toast?.('Embed code copied!');}}>Copy code</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
